// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Page_page__3Ax9U {\n    padding: 20px;\n    display: \"flex\";\n    flex-direction: column;\n}", "",{"version":3,"sources":["webpack://src/components/page/Page.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B","sourcesContent":[".page {\n    padding: 20px;\n    display: \"flex\";\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "Page_page__3Ax9U"
};
export default ___CSS_LOADER_EXPORT___;
